<template>
  <Modal
    v-model="_value"
    width="500"
    title="设置汇报间隔"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="setupReportInterval" autoComplete="on" v-model="setupReportInterval"
          class="card-box login-form">
      <FormItem prop="driverCardNum">
        <label style="display: inline-block; width: 100px;">ACC开上传间隔</label>
        <InputNumber :min="0" :step="1" style="display: inline-block; width: 200px;"
                     v-model="setupReportInterval.accOn" placeholder="请输入ACC开上传间隔">
        </InputNumber>
      </FormItem>
      <FormItem prop="driverLicenseNum">
        <label style="display: inline-block; width: 100px;">ACC关上传间隔</label>
        <InputNumber :min="0" :step="1" style="display: inline-block; width: 200px;"
                     v-model="setupReportInterval.accOff" placeholder="请输入ACC关上传间隔">
        </InputNumber>
      </FormItem>
      <Button type="primary" @click="onSetupReportInterval">发送</Button>
    </Form>
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'


export default {
  name: 'setreportingintervalmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setupReportInterval: {
        id: null,
        accOn: 15,
        accOff: 120
      },

    }
  },
  methods: {
    ...mapActions([
    ]),
    visibleChange (val) {
      if (val) {
        this.setupReportInterval.id = this._initValue
      }
    },
    onSetupReportInterval () {
      store.dispatch('NetCommandServ_SetupReportInterval', {
        params: this.setupReportInterval
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
